enum ModelId {
  imageObjectDetection = "84a13911-11e0-4146-8452-333f9340f576",
  imageObjectDetectionAerial = "224bb13c-c533-4e03-a8e6-42bbb313e19f",
  imageClassification = "dccdbd47-8a6b-416c-9733-1a65a2701e73",
}

export default ModelId;
